module.exports = __webpack_public_path__ + "static/media/like.a90d7700.svg";